import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompanyAccountComponent } from 'src/components/company-account/company-account.component';
import { ProcessListComponent } from 'src/components/process-list/process-list.component';
import { SelectionTestComponent } from 'src/components/selection-test/selection-test.component';
import { UsersComponent } from 'src/components/users/users.component';
import { VoucherComponentComponent } from 'src/components/voucher-component/voucher-component.component';
import { AuthGuard } from 'src/guards/auth.guard';
import { RecruiterComponent } from 'src/views/recruiter/recruiter.component';
import { AnalyticsComponent } from 'src/components/analytics/analytics.component';
import { MyAccountCompanyComponent } from 'src/components/my-account-company/my-account-company.component';
import { PaineladmComponent } from 'src/components/paineladm/paineladm.component';
import { WelcomeComponent } from 'src/components/welcome/welcome.component';
//import { RecruiterReportComponent } from 'src/components/recruiter-report/recruiter-report.component';
import { RecruiterSearchComponent } from 'src/components/recruiter-search/recruiter-search.component';
import { PaymentComponent } from 'src/components/payment/payment.component';
import { ApproveRecruitersComponent } from 'src/components/approve-recruiters/approve-recruiters.component';
import { SendNotificationComponent } from 'src/components/send-notification/send-notification.component';

const routes: Routes = [
  {
    path: 'recruiter', component: RecruiterComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'list' },
      { path: 'list', component: ProcessListComponent },
      { path: 'tests', component: SelectionTestComponent },
      { path: 'users', component: UsersComponent },
      { path: 'account', component: CompanyAccountComponent },
      { path: 'voucher', component: VoucherComponentComponent },
      { path: 'analytics', component: AnalyticsComponent },
      { path: 'finance', component: MyAccountCompanyComponent },
      { path: 'painel-adm', component: PaineladmComponent },
      { path: 'welcome', component: WelcomeComponent },
      { path: 'payment', component: PaymentComponent },
      { path: 'notification', component: SendNotificationComponent },
      { path: 'approve-recruiters', component: ApproveRecruitersComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RecruiterRoutingModule { }
